import { render, staticRenderFns } from "./DetailType.vue?vue&type=template&id=2385e6c5"
import script from "./DetailType.vue?vue&type=script&lang=js"
export * from "./DetailType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports